export default function BrandCarousel() {
  return null;
}
